<template>
  <div>
    <div v-if="loading" class="text-center p-50">
      <i class="fa fa-spin fa-5x fa-spinner"></i>
    </div>
    <div v-else class="block block-bordered">
        <div class="block-header block-header-default">
        </div>
        <div class="block-content p-0">
          <table class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th>Referentie nummer</th>
                <th>Totaal bedrag</th>
                <th>Openstaand bedrag</th>
                <th>Geüploade bestanden</th>
                <th>Upload</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="paymentTransaction in paymentTransactions" :key="paymentTransaction">
                <td> {{paymentTransaction.reference}} </td>
                <td> € {{paymentTransaction.amount}} </td>
                <td> € {{paymentTransaction.openAmount}} </td>
                <td>
                  <span v-if="paymentTransaction.files.length == 0">Geen bestanden geüpload</span>
                  <div v-else style="display:flex; flex-direction:column">
                    <span v-for="file in paymentTransaction.files" :key="file"> {{file}} </span> 
                  </div>
                </td>
                <td>
                  <div class="row">
                    <input type="file" class="form-control" v-on:change="onFileChange" style="width: 350px;">
                    <button type="submit" class="btn btn-success btn-noborder" @click="uploadFile(paymentTransaction)">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
    <button v-if="!loading" type="submit" class="btn btn-danger btn-noborder" @click="deleteFiles()">
      Verwijder alle bestanden
    </button>
  </div>
</template>
<script>
import http from '../utils/http'

export default {
  data () {
    return {
      paymentTransactions: null,
      file: null,
      loading: false
    }
  },
  methods: {
    loadData () {
      this.loading = true

      http.get('/amazon/settlement-references')
        .then((result) => {
          this.paymentTransactions = result.data.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het ophalen van de amazon settlements. Probeer het opnieuw.', 'warning')
        })
    },
    onFileChange (e) {
      this.file = e.target.files[0]
    },
    uploadFile (paymentTransaction) {
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }

      let formData = new FormData()
      formData.append('file', this.file)

      formData.append('name', paymentTransaction.reference)

      http.post('/amazon/upload-xml', formData, config)
        .then((result) => {
          this.file = null
          this.$swal('Hoera 😊', `Bestand is succesvol geupload.`, 'success')
          this.loadData()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan met het uploaden van de amazon xml. Probeer het opnieuw.', 'warning')
        })
    },
    deleteFiles () {
      this.$http.delete(`/amazon/delete-all-xmls`)
      .then((response) => {
        this.$swal('Hoera 😊', `De bestanden zijn succesvol verwijderen.`, 'success')
        this.loadData()
      })
      .catch(() => {
        this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het verwijderen van de bestanden. Probeer het opnieuw.`, 'error')
      })
    }
  },
  created () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// AmazonXmlUploadTab.vue?720231b3